import { useState, useEffect } from 'react';
import {
    InputDinamycPlaceholder,
    Checkbox,
    DropDownSelector
} from "@lk-gtcom/ecomlab-components";
import './ModalSettingsView.scss'
import { TextPage } from '../../../components/TextPage/TextPage';
import ColorPicker from '../../../components/ColorPicker/ColorPicker';
import { TitlePage } from '../../../components/TitlePage/TitlePage';

const ModalSettingsView = ({
    isModalView,
    setIsModal,
    initialSettings = {}
}) => {

    const { id, type } = isModalView

    // Общие настройки
    const [isBorder, setIsborder] = useState(initialSettings.isBorder || false)
    const [borderColor, setBorderColor] = useState(initialSettings.borderColor || '#000000')
    const [borderWidth, setBorderWidth] = useState(initialSettings.borderWidth || 1)
    const [borderStyle, setBorderStyle] = useState({ value: 'solid', label: 'Сплошная' })
    const [borderRadius, setBorderRadius] = useState(initialSettings.borderRadius || 0)

    // Настройки для картинки
    const [maxWidth, setMaxWidth] = useState(initialSettings.maxWidth || 100)
    const [maxHeight, setMaxHeight] = useState(initialSettings.maxHeight || 100)
    const [padding, setPadding] = useState(initialSettings.padding || 0)

    // Настройки для текста
    const [textMaxWidth, setTextMaxWidth] = useState(initialSettings.textMaxWidth || 100)

    // Настройки для info блока
    const [backgroundColor, setBackgroundColor] = useState(initialSettings.backgroundColor || '#ffffff')
    const [isBackground, setIsBackground] = useState(initialSettings.isBackground || false)
    const [infoPadding, setInfoPadding] = useState(initialSettings.infoPadding || 0)

    // Настройки для формы
    const [labelText, setLabelText] = useState(initialSettings.labelText || 'Заголовок формы')
    const [buttonText, setButtonText] = useState(initialSettings.buttonText || 'Отправить')
    const [textColor, setTextColor] = useState(initialSettings.textColor || '#000000')
    const [formPadding, setFormPadding] = useState(initialSettings.formPadding || 0)
    const [formBorderColor, setFormBorderColor] = useState(initialSettings.formBorderColor || '#000000')
    const [formBorderWidth, setFormBorderWidth] = useState(initialSettings.formBorderWidth || 1)
    const [isFormBorder, setIsFormBorder] = useState(initialSettings.isFormBorder || false)

    // Настройки для аккордеона
    const [accordionTitleColor, setAccordionTitleColor] = useState(initialSettings.accordionTitleColor || '#000000')
    const [accordionTextColor, setAccordionTextColor] = useState(initialSettings.accordionTextColor || '#000000')
    const [accordionBorderColor, setAccordionBorderColor] = useState(initialSettings.accordionBorderColor || '#000000')
    const [accordionBorderWidth, setAccordionBorderWidth] = useState(initialSettings.accordionBorderWidth || 1)
    const [accordionBorderRadius, setAccordionBorderRadius] = useState(initialSettings.accordionBorderRadius || 0)
    const [isAccordionBorder, setIsAccordionBorder] = useState(initialSettings.isAccordionBorder || false)

    // Опции для стилей обводки
    const options_prop = [
        { value: 'solid', label: 'Сплошная' },
        { value: 'dashed', label: 'Пунктирная' },
        { value: 'dotted', label: 'Точечная' },
        { value: 'double', label: 'Двойная' },
        { value: 'groove', label: 'Объемная (groove)' },
        { value: 'ridge', label: 'Рельефная (ridge)' },
        { value: 'inset', label: 'Вдавленная' },
        { value: 'outset', label: 'Выпуклая' }
    ]

    // Инициализация значений из initialSettings
    useEffect(() => {
        if (initialSettings.labelText) setLabelText(initialSettings.labelText)
        if (initialSettings.buttonText) setButtonText(initialSettings.buttonText)
        if (initialSettings.textColor) setTextColor(initialSettings.textColor)
        if (initialSettings.formPadding) setFormPadding(initialSettings.formPadding)
        if (initialSettings.formBorderColor) setFormBorderColor(initialSettings.formBorderColor)
        if (initialSettings.formBorderWidth) setFormBorderWidth(initialSettings.formBorderWidth)
        if (initialSettings.isFormBorder !== undefined) setIsFormBorder(initialSettings.isFormBorder)
        if (initialSettings.borderStyle) setBorderStyle(initialSettings.borderStyle)
        // Аккордеон
        if (initialSettings.accordionTitleColor) setAccordionTitleColor(initialSettings.accordionTitleColor)
        if (initialSettings.accordionTextColor) setAccordionTextColor(initialSettings.accordionTextColor)
        if (initialSettings.accordionBorderColor) setAccordionBorderColor(initialSettings.accordionBorderColor)
        if (initialSettings.accordionBorderWidth) setAccordionBorderWidth(initialSettings.accordionBorderWidth)
        if (initialSettings.accordionBorderRadius) setAccordionBorderRadius(initialSettings.accordionBorderRadius)
        if (initialSettings.isAccordionBorder !== undefined) setIsAccordionBorder(initialSettings.isAccordionBorder)
    }, [initialSettings])

    return (
        <div className='blackout'
            onClick={(e) => {
                let el = e.target
                if (el.classList.contains('blackout')) {
                    setIsModal(false)
                }
            }}>
            <div className='modal-settings-view'>
                <TitlePage
                    title={`Настройки для блока ID-${id}`}
                />

                {type == 'image' &&
                    <div className='modal-settings-view__content'>
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Размеры'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={100}
                                    size="s"
                                    value={maxWidth}
                                    onChange={(value) => setMaxWidth(value)}
                                    placeholder="Максимальная ширина"
                                    tooltipStatic={'Значение в процентах (0-100%)'}
                                />

                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={100}
                                    size="s"
                                    value={maxHeight}
                                    onChange={(value) => setMaxHeight(value)}
                                    placeholder="Максимальная высота"
                                    tooltipStatic={'Значение в процентах (0-100%)'}
                                />
                            </div>
                        </div>

                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Обводка'
                            />

                            <div className='modal-settings-view__row'>
                                <Checkbox
                                    value={isBorder}
                                    onChange={() => setIsborder(!isBorder)}
                                >
                                    Включить обводку
                                </Checkbox>
                            </div>

                            {isBorder && (
                                <>
                                    <div className='modal-settings-view__row'>
                                        <ColorPicker
                                            label="Цвет обводки"
                                            value={borderColor}
                                            onChange={setBorderColor}
                                        />

                                        <InputDinamycPlaceholder
                                            type='number'
                                            min={1}
                                            max={20}
                                            size="s"
                                            changeValue={borderWidth}
                                            onChange={(value) => setBorderWidth(value)}
                                            placeholder="Толщина"
                                            tooltipStatic={'Толщина обводки в пикселях (1-20px)'}
                                            suffix="px"
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Скругление углов'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={50}
                                    size="s"
                                    changeValue={borderRadius}
                                    onChange={(value) => setBorderRadius(value)}
                                    placeholder="Скругление всех углов"
                                    tooltipStatic={'Скругление в пикселях (0-50px)'}
                                    suffix="px"
                                />
                            </div>
                        </div>

                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Отступы'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={50}
                                    size="s"
                                    changeValue={padding}
                                    onChange={(value) => setPadding(value)}
                                    placeholder="Внутренние отступы"
                                    tooltipStatic={'Отступы внутри блока в пикселях'}
                                    suffix="px"
                                />
                            </div>
                        </div>
                    </div>
                }

                {((type == 'text') || (type == 'title')) &&
                    <div className='modal-settings-view__content'>
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Размеры'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={100}
                                    size="s"
                                    value={textMaxWidth}
                                    onChange={(value) => setTextMaxWidth(value)}
                                    placeholder="Максимальная ширина"
                                    tooltipStatic={'Значение в процентах (0-100%)'}
                                    suffix="%"
                                />
                            </div>
                        </div>

                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Обводка текста'
                            />

                            <div className='modal-settings-view__row'>
                                <Checkbox
                                    value={isBorder}
                                    onChange={() => setIsborder(!isBorder)}
                                >
                                    Включить обводку текста
                                </Checkbox>
                            </div>

                            {isBorder && (
                                <>
                                    <div className='modal-settings-view__row'>
                                        <DropDownSelector
                                            isClearable={false}
                                            options_prop={options_prop}
                                            state={borderStyle}
                                            setState={(e) => setBorderStyle(e)}
                                            placeholder="Стиль обводки"
                                        />

                                        <InputDinamycPlaceholder
                                            type='number'
                                            min={1}
                                            max={10}
                                            size="s"
                                            value={borderWidth}
                                            onChange={(value) => setBorderWidth(value)}
                                            placeholder="Толщина обводки"
                                            tooltipStatic={'Толщина обводки текста (1-10px)'}
                                            suffix="px"
                                        />
                                    </div>

                                    <div className='modal-settings-view__row'>
                                        <ColorPicker
                                            label="Цвет обводки"
                                            value={borderColor}
                                            onChange={setBorderColor}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                }

                {type == 'info' &&
                    <div className='modal-settings-view__content'>
                        {/* Размеры */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Размеры'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={100}
                                    size="s"
                                    value={textMaxWidth}
                                    onChange={(value) => setTextMaxWidth(value)}
                                    placeholder="Максимальная ширина"
                                    tooltipStatic={'Значение в процентах (0-100%)'}
                                    suffix="%"
                                />
                            </div>
                        </div>

                        {/* Фон */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Фон'
                            />

                            <div className='modal-settings-view__row'>
                                <Checkbox
                                    value={isBackground}
                                    onChange={() => setIsBackground(!isBackground)}
                                >
                                    Включить фон
                                </Checkbox>
                            </div>

                            {isBackground && (
                                <div className='modal-settings-view__row'>
                                    <ColorPicker
                                        label="Цвет фона"
                                        value={backgroundColor}
                                        onChange={setBackgroundColor}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Обводка блока */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Обводка блока'
                            />

                            <div className='modal-settings-view__row'>
                                <Checkbox
                                    value={isBorder}
                                    onChange={() => setIsborder(!isBorder)}
                                >
                                    Включить обводку
                                </Checkbox>
                            </div>

                            {isBorder && (
                                <>
                                    <div className='modal-settings-view__row'>
                                        <DropDownSelector
                                            isClearable={false}
                                            options_prop={options_prop}
                                            state={borderStyle}
                                            setState={(e) => setBorderStyle(e)}
                                            placeholder="Стиль обводки"
                                        />

                                        <InputDinamycPlaceholder
                                            type='number'
                                            min={1}
                                            max={10}
                                            size="s"
                                            value={borderWidth}
                                            onChange={(value) => setBorderWidth(value)}
                                            placeholder="Толщина обводки"
                                            tooltipStatic={'Толщина обводки (1-10px)'}
                                            suffix="px"
                                        />
                                    </div>

                                    <div className='modal-settings-view__row'>
                                        <ColorPicker
                                            label="Цвет обводки"
                                            value={borderColor}
                                            onChange={setBorderColor}
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Скругление углов */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Скругление углов'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={50}
                                    size="s"
                                    value={borderRadius}
                                    onChange={(value) => setBorderRadius(value)}
                                    placeholder="Скругление всех углов"
                                    tooltipStatic={'Скругление в пикселях (0-50px)'}
                                    suffix="px"
                                />
                            </div>
                        </div>

                        {/* Внутренние отступы */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Внутренние отступы'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={50}
                                    size="s"
                                    value={infoPadding}
                                    onChange={(value) => setInfoPadding(value)}
                                    placeholder="Отступы внутри блока"
                                    tooltipStatic={'Внутренние отступы в пикселях'}
                                    suffix="px"
                                />
                            </div>
                        </div>
                    </div>
                }

                {type == 'form' &&
                    <div className='modal-settings-view__content'>
                        {/* Текст формы */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Текст формы'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='text'
                                    size="s"
                                    value={labelText}
                                    onChange={(value) => setLabelText(value)}
                                    placeholder="Текст надписи формы"
                                    tooltipStatic={'Введите текст для заголовка формы'}
                                />
                            </div>

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='text'
                                    size="s"
                                    value={buttonText}
                                    onChange={(value) => setButtonText(value)}
                                    placeholder="Текст кнопки"
                                    tooltipStatic={'Введите текст для кнопки отправки формы'}
                                />
                            </div>

                            <div className='modal-settings-view__row'>
                                <ColorPicker
                                    label="Цвет текста"
                                    value={textColor}
                                    onChange={setTextColor}
                                />
                            </div>
                        </div>

                        {/* Размеры */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Размеры'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={100}
                                    size="s"
                                    value={textMaxWidth}
                                    onChange={(value) => setTextMaxWidth(value)}
                                    placeholder="Максимальная ширина"
                                    tooltipStatic={'Значение в процентах (0-100%)'}
                                    suffix="%"
                                />
                            </div>
                        </div>

                        {/* Отступы */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Отступы'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={50}
                                    size="s"
                                    value={formPadding}
                                    onChange={(value) => setFormPadding(value)}
                                    placeholder="Внутренние отступы формы"
                                    tooltipStatic={'Отступы внутри формы в пикселях'}
                                    suffix="px"
                                />
                            </div>
                        </div>

                        {/* Обводка формы */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Обводка формы'
                            />

                            <div className='modal-settings-view__row'>
                                <Checkbox
                                    value={isFormBorder}
                                    onChange={() => setIsFormBorder(!isFormBorder)}
                                >
                                    Включить обводку формы
                                </Checkbox>
                            </div>

                            {isFormBorder && (
                                <>
                                    <div className='modal-settings-view__row'>
                                        <DropDownSelector
                                            isClearable={false}
                                            options_prop={options_prop}
                                            state={borderStyle}
                                            setState={(e) => setBorderStyle(e)}
                                            placeholder="Стиль обводки"
                                        />

                                        <InputDinamycPlaceholder
                                            type='number'
                                            min={1}
                                            max={10}
                                            size="s"
                                            value={formBorderWidth}
                                            onChange={(value) => setFormBorderWidth(value)}
                                            placeholder="Толщина обводки"
                                            tooltipStatic={'Толщина обводки формы (1-10px)'}
                                            suffix="px"
                                        />
                                    </div>

                                    <div className='modal-settings-view__row'>
                                        <ColorPicker
                                            label="Цвет обводки формы"
                                            value={formBorderColor}
                                            onChange={setFormBorderColor}
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Фон формы */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Фон формы'
                            />

                            <div className='modal-settings-view__row'>
                                <Checkbox
                                    value={isBackground}
                                    onChange={() => setIsBackground(!isBackground)}
                                >
                                    Включить фон формы
                                </Checkbox>
                            </div>

                            {isBackground && (
                                <div className='modal-settings-view__row'>
                                    <ColorPicker
                                        label="Цвет фона формы"
                                        value={backgroundColor}
                                        onChange={setBackgroundColor}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Скругление углов формы */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Скругление углов'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={50}
                                    size="s"
                                    value={borderRadius}
                                    onChange={(value) => setBorderRadius(value)}
                                    placeholder="Скругление всех углов формы"
                                    tooltipStatic={'Скругление в пикселях (0-50px)'}
                                    suffix="px"
                                />
                            </div>
                        </div>
                    </div>
                }

                {type == 'accordion' &&
                    <div className='modal-settings-view__content'>
                        {/* Цвета текста */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Цвета текста'
                            />

                            <div className='modal-settings-view__row'>
                                <ColorPicker
                                    label="Цвет заголовка аккордеона"
                                    value={accordionTitleColor}
                                    onChange={setAccordionTitleColor}
                                />
                            </div>

                            <div className='modal-settings-view__row'>
                                <ColorPicker
                                    label="Цвет текста содержимого"
                                    value={accordionTextColor}
                                    onChange={setAccordionTextColor}
                                />
                            </div>
                        </div>

                        {/* Обводка аккордеона */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Обводка аккордеона'
                            />

                            <div className='modal-settings-view__row'>
                                <Checkbox
                                    value={isAccordionBorder}
                                    onChange={() => setIsAccordionBorder(!isAccordionBorder)}
                                >
                                    Включить обводку аккордеона
                                </Checkbox>
                            </div>

                            {isAccordionBorder && (
                                <>
                                    <div className='modal-settings-view__row'>
                                        <DropDownSelector
                                            isClearable={false}
                                            options_prop={options_prop}
                                            state={borderStyle}
                                            setState={(e) => setBorderStyle(e)}
                                            placeholder="Стиль обводки"
                                        />

                                        <InputDinamycPlaceholder
                                            type='number'
                                            min={1}
                                            max={10}
                                            size="s"
                                            value={accordionBorderWidth}
                                            onChange={(value) => setAccordionBorderWidth(value)}
                                            placeholder="Толщина обводки"
                                            tooltipStatic={'Толщина обводки аккордеона (1-10px)'}
                                            suffix="px"
                                        />
                                    </div>

                                    <div className='modal-settings-view__row'>
                                        <ColorPicker
                                            label="Цвет обводки аккордеона"
                                            value={accordionBorderColor}
                                            onChange={setAccordionBorderColor}
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Размеры */}
                        <div className='modal-settings-view__section'>
                            <TitlePage
                                style={{ fontWeight: 700 }}
                                medium
                                title='Размеры'
                            />

                            <div className='modal-settings-view__row'>
                                <InputDinamycPlaceholder
                                    type='number'
                                    min={0}
                                    max={100}
                                    size="s"
                                    value={textMaxWidth}
                                    onChange={(value) => setTextMaxWidth(value)}
                                    placeholder="Максимальная ширина"
                                    tooltipStatic={'Значение в процентах (0-100%)'}
                                    suffix="%"
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export { ModalSettingsView }